module.exports = __webpack_public_path__ + "img/confused.002e6676.svg";